import React, { useEffect, useState } from 'react';
const rightArrow = '/icons/linkRightArrow.svg';
import styles from './Factory.module.scss';
import Text from '../../../atoms/text/Text';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { closeAllModals } from '../../../../app/globals/slice/sideModalSlice/SideModalSlice';
import useIsRtl from '../../../../app/helpers/isRtl';

const Menu = ({ data, className, onMouseEnter }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isRtl = useIsRtl();
  const [activeLink, setActiveLink] = useState(null);

  const navigateTo = (item) => {
    dispatch(closeAllModals());
    setTimeout(() => {
      navigate(item.route, {
        state: item.routeState,
      });
    }, 500);
  };

  const handleMouseEnter = (index) => {
    setActiveLink(index);
    onMouseEnter(index);
  };

  return (
    <div
      className={`${styles.menu} ${className ?? ''} ${
        isRtl ? styles['rtl-menu'] : ''
      } ${activeLink ? styles.borderRight : null}`}
    >
      {data?.map((item, index) => {
        if (item.hidden) return null;
        return (
          <Link
            key={index}
            to={item.route}
            state={item.routeState}
            onClick={(e) => {
              e.preventDefault();
              dispatch(closeAllModals());
              setTimeout(() => {
                navigate(item.route, {
                  state: item.routeState,
                });
              }, 500);
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            style={{ cursor: 'pointer', textDecoration: 'none' }}
          >
            <Text
              variant="text-bold-italic-18"
              title={item.title}
              style={{ textTransform: 'uppercase' }}
              svg={item.children ? rightArrow : null}
              svgPosition="right"
              className={`${styles.link} ${activeLink === index ? styles['active-link'] : ''}`}
            />
          </Link>
        );
      })}
    </div>
  );
};

const Navigation = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  let gridClass = styles['sub-menu'];

  if (data && data[2]?.children) {
    gridClass = `${styles['sub-menu']} ${styles['flexed-row']}`;
  }
  const handleNav = (item, isChild) => {
    dispatch(closeAllModals());

    setTimeout(() => {
      navigate(item.route, {
        state: item.routeState,
        replace: item.shouldReplace,
      });
    }, 500);
  };

  useEffect(() => {
    const lang = localStorage.getItem('language');
    if (lang === 'ar') {
      setLoading(false);
    } else {
      const timeout = setTimeout(() => setLoading(false), 300);
      return () => clearTimeout(timeout);
    }
  }, []);
  const blurryClass = styles.blurry;

  return (
    <div className={styles.navigation}>
      <div className={gridClass}>
        {data?.map((child, index) => {
          if (child?.hidden) return null;
          if (child.children) {
            return (
              <div className={styles['inner-child-container']} key={index}>
                <div key={index} className={styles['text-wrapper']}>
                  <Link
                    to={child.route}
                    state={child.routeState}
                    replace={child.shouldReplace}
                    style={{ cursor: 'pointer', textDecoration: 'none' }}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(closeAllModals());
                      setTimeout(() => {
                        navigate(child.route, {
                          state: child.routeState,
                          replace: child.shouldReplace,
                        });
                      }, 500);
                    }}
                  >
                    <Text
                      variant="text-bold-italic-18"
                      title={child?.title}
                      className={`${styles['child-link']} ${loading ? blurryClass : ''} ${loading ? 'blurry' : ''}`}
                      style={{ textTransform: 'uppercase', cursor: 'pointer' }}
                    />
                  </Link>
                </div>
                {child?.children?.map((sub, subIndex) =>
                  sub.title ? (
                    <div
                      key={subIndex}
                      className={styles['inner-subs-container']}
                    >
                      <Link
                        to={sub.route}
                        state={
                          sub.routeState || {
                            id: 'baf66628-ff3b-4b40-ac0d-1ac43e089a59',
                          }
                        }
                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(closeAllModals());
                          setTimeout(() => {
                            navigate(sub.route, {
                              state: sub.routeState || {
                                id: 'baf66628-ff3b-4b40-ac0d-1ac43e089a59',
                              },
                              replace: sub.shouldReplace,
                            });
                          }, 500);
                        }}
                      >
                        <Text
                          variant="text-regular-14"
                          className={`${styles['child-link']} ${loading ? blurryClass : ''} ${loading ? 'blurry' : ''}`}
                          title={sub?.title}
                          style={{
                            textTransform: 'uppercase',
                            cursor: 'pointer',
                          }}
                        />
                      </Link>
                    </div>
                  ) : null
                )}
              </div>
            );
          } else {
            return (
              <div key={index} className={styles['text-wrapper']}>
                <Text
                  variant="text-regular-16"
                  title={child?.title}
                  className={`${styles['child-link']} ${loading ? blurryClass : ''} ${loading ? 'blurry' : ''}`}
                  style={{ textTransform: 'uppercase' }}
                  onClick={() => handleNav(child)}
                />
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export { Menu, Navigation };
